import { CSESelectable } from 'elements/selectable/selectable.js'

export interface SelectableStrategy {
  handleClick(index: number): void
  updateState(): void
}

export class SingleSelectableStrategy implements SelectableStrategy {
  constructor(
    private getSelectables: () => CSESelectable[],
    private getSelectedIndices: () => number[],
    private setSelectedIndices: (indices: number[]) => void,
    private dispatch: (event: CustomEvent) => void
  ) {}

  handleClick(index: number): void {
    const selectables = this.getSelectables()
    const clicked = selectables[index]

    if (!clicked || clicked.state === 'disabled' || clicked.state === 'loading') {
      return
    }

    this.setSelectedIndices([index])
    this.updateState()

    this.dispatch(new CustomEvent('cse-selectable-selected', {
      detail: {
        index,
        element: clicked,
        selectedElements: [clicked],
      },
      bubbles: true,
      composed: true,
    }))
  }

  updateState(): void {
    const selectables = this.getSelectables()
    const selectedIndices = this.getSelectedIndices()
    const selectedIndex = selectedIndices.length > 0 ? selectedIndices[0] : null

    selectables.forEach((item, index) => {
      if (item.state !== 'disabled' && item.state !== 'loading') {
        item.state = index === selectedIndex ? 'selected' : 'selectable'
      }
    })
  }
}


export class MultipleSelectableStrategy implements SelectableStrategy {
  constructor(
    private getSelectables: () => CSESelectable[],
    private getSelectedIndices: () => number[],
    private setSelectedIndices: (indices: number[]) => void,
    private dispatch: (event: CustomEvent) => void
  ) {}

  handleClick(index: number): void {
    const selectables = this.getSelectables()
    const clicked = selectables[index]

    if (!clicked || clicked.state === 'disabled' || clicked.state === 'loading') {
      return
    }

    const current = new Set(this.getSelectedIndices())

    if (current.has(index)) {
      current.delete(index)
    } else {
      current.add(index)
    }

    const newIndices = [...current].sort((a, b) => a - b)

    this.setSelectedIndices(newIndices)
    this.updateState()

    const selectedElements = newIndices.map(i => selectables[i])

    this.dispatch(new CustomEvent('cse-selectable-selected', {
      detail: {
        indices: newIndices,
        selectedElements,
      },
      bubbles: true,
      composed: true,
    }))
  }


  updateState(): void {
    const selectables = this.getSelectables()
    const selectedIndices = new Set(this.getSelectedIndices())

    selectables.forEach((item, index) => {
      if (item.state !== 'disabled' && item.state !== 'loading') {
        item.state = selectedIndices.has(index) ? 'selected' : 'selectable'
      }
    })
  }
}
